import mammoth from 'mammoth';
import * as XLSX from 'xlsx';

// Tarefa 8.3 (FR-059/FR-060): conversao client-side de documentos do Office
// para pre-visualizacao no painel de conteudo da tela "Detalhe da Skill" -
// mesmo padrao "decodificar base64 -> chamar a biblioteca -> renderizar o
// resultado" para os dois formatos.

// Exportada para reuso por pptxPreview.js (Tarefa 8.4) - mesma conversao
// base64 -> bytes, sem duplicar a implementacao pela terceira vez.
export function base64ToUint8Array(base64) {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return bytes;
}

// Estilo do preview de .docx - o <iframe sandbox=""> e' um documento a parte
// (nao herda nenhum CSS da aplicacao), entao o HTML cru do mammoth (so
// tags semanticas, sem estilo nenhum) saia com a tipografia padrao do
// navegador. Valores emprestados de `.skill-detail-content-markdown`
// (SkillsManagerModal.css, preview do .md) pra ficar visualmente consistente
// com o resto da tela "Detalhe da Skill", sem depender de fontes externas
// (o documento gerado e' isolado - sem @font-face nem carregar 'Poppins' do
// app, so' uma pilha de fontes do sistema).
const DOCX_PREVIEW_STYLE = `
  body {
    margin: 0;
    padding: 24px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
    font-size: 14px;
    line-height: 1.6;
    color: #333;
  }
  h1, h2, h3, h4, h5, h6 { margin: 24px 0 12px; font-weight: 600; color: #000; line-height: 1.3; }
  h1:first-child, h2:first-child, h3:first-child, h4:first-child { margin-top: 0; }
  h1 { font-size: 22px; padding-bottom: 8px; border-bottom: 1px solid #cdd1d6; }
  h2 { font-size: 19px; padding-bottom: 6px; border-bottom: 1px solid #cdd1d6; }
  h3 { font-size: 16px; }
  h4, h5, h6 { font-size: 14px; color: #4e4d4d; }
  p { margin: 0 0 14px; }
  strong, b { font-weight: 600; color: #000; }
  em, i { font-style: italic; color: #4e4d4d; }
  a { color: #0067ff; text-decoration: none; }
  a:hover { text-decoration: underline; }
  ul, ol { margin: 0 0 14px; padding-left: 22px; }
  li { margin-bottom: 4px; }
  hr { margin: 20px 0; border: none; border-top: 1px solid #cdd1d6; }
  blockquote {
    margin: 0 0 14px;
    padding: 4px 16px;
    border-left: 3px solid #0067ff;
    color: #4e4d4d;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 0 8px 8px 0;
  }
  table { width: 100%; margin: 0 0 14px; border-collapse: collapse; font-size: 13px; }
  th, td { padding: 8px 12px; border: 1px solid #c7d6e4; text-align: left; }
  th { font-weight: 600; color: #f1f1f4; background: #1e1e2e; }
  img { max-width: 100%; border-radius: 8px; }
`;

function wrapDocxHtmlDocument(bodyHtml) {
    return `<!doctype html><html><head><meta charset="utf-8"><style>${DOCX_PREVIEW_STYLE}</style></head><body>${bodyHtml}</body></html>`;
}

// FR-059: .docx -> HTML via mammoth, envolvido num documento HTML completo
// com estilo proprio (acima). O resultado e' exibido num <iframe
// sandbox=""> (SkillDetailView.js), mesmo tratamento ja dado a .html
// (Tarefa 8.2) - conteudo importado por upload, nunca injetado direto no DOM
// da aplicacao.
export async function convertDocxToHtml(base64) {
    const { buffer, byteOffset, byteLength } = base64ToUint8Array(base64);
    const arrayBuffer = buffer.slice(byteOffset, byteOffset + byteLength);
    const result = await mammoth.convertToHtml({ arrayBuffer });
    return wrapDocxHtmlDocument(result.value);
}

// FR-060: primeira planilha do .xlsx -> array de arrays (mesmo formato de
// csvPreview.js::parseCsv), pronta pro componente de tabela compartilhado
// (DataTable, SkillDetailView.js). `[SIMPLIFICACAO ASSUMIDA]`: demais
// planilhas do arquivo (se houver) nao sao exibidas nesta rodada.
export function parseXlsxFirstSheet(base64) {
    const bytes = base64ToUint8Array(base64);
    const workbook = XLSX.read(bytes, { type: 'array' });
    const firstSheetName = workbook.SheetNames[0];
    if (!firstSheetName) return [];
    const sheet = workbook.Sheets[firstSheetName];
    return XLSX.utils.sheet_to_json(sheet, { header: 1, raw: false, defval: '' });
}
